import { apiSlice } from './baseApi';

export const companyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyById: builder.query({
      query: (companyId) => ({
        url: '/company/get-company-by-id',
        method: 'POST',
        body: { company_id: companyId },
      }),
      transformResponse: (response) => response?.companies ?? {},
      providesTags: ['Company'],
    }),
  }),
});
